/**
 * The About dialog's "Release dato" / "Version" pair (sidebar.tsx), and the
 * `platform_version` stamped on a ToS/PP acceptance (pages/Auth/TosAndPP).
 *
 * ⚠️ MAINTAINED BY HAND, despite what this header said until PD-2985. There IS
 * a generator — `node-script/store-version.js`, exposed as the
 * `generate-version` npm script — but NO build calls it: `build:prod` (the one
 * the `v*.*.*` tag runs) and `build:develop` both go straight to webpack. So
 * the two values below sat at `0.0.1` / `18.01.2023` from the one time someone
 * ran the script in January 2023 until the customer read them off production.
 *
 * That block sits next to the CE mark and the UDI-DI, so it is regulatory
 * labelling: it has to say what is actually deployed. Until the production
 * build stamps it, EDIT IT IN THE RELEASE PR — and note the git tag scheme
 * (`v1.4.x`) is NOT this number, so a generator wired to the tag would print
 * the wrong one.
 */

export const appVersion = '2026.3.0';
export const appDeployDate = '03.11.2026';
